<template>
  <div>
    <el-form
      :inline="true"
      ref="formRef"
      :model="ruleForm"
      :rules="rules"
      class="userForm"
      label-width="100px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="库名称" prop="libraryName">
            <el-input
              style="width: 100%"
              v-model="ruleForm.libraryName"
              placeholder="请输入库名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="库类别" prop="libraryFlag">
            <el-select
              style="width: 100%"
              @change="changeLibraryFlag"
              v-model="ruleForm.libraryFlag"
              placeholder=""
            >
              <el-option
                v-for="item in libraryFlagData"
                :key="item.value"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="库类型" prop="libraryType">
            <!-- v-if="ruleForm.libraryFlag == '1'" -->
            <h-selectcode
              v-if="listLibrary"
              v-model:dictData="listLibrary"
              v-model="ruleForm.libraryType"
              placeholder="请选择库类型"
              :clearable="true"
            ></h-selectcode>
            <!-- <el-select
              v-else
              style="width: 100%"
              @change="selectChange"
              placeholder=""
            >
              <el-option
                v-for="item in []"
                :key="item.value"
                :label="item.value"
                :value="item.code"
              ></el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="库简称" prop="libraryAbbreviation">
            <el-input
              style="width: 100%"
              v-model="ruleForm.libraryAbbreviation"
              placeholder="请输入库简称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="同步库编号" prop="syncId">
            <el-select
              v-if="syncIdList"
              v-model="ruleForm.syncId"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in syncIdList"
                :key="item.tabId"
                :label="item.groupName"
                :value="item.tabId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="同步状态" prop="syncFlag">
            <h-selectcode
              type="sync_flag"
              v-model="ruleForm.syncFlag"
              placeholder="请选择同步状态"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="是否重点" prop="importanceFlag">
            <h-selectcode
              type="unit_import_type"
              v-model="ruleForm.importanceFlag"
              placeholder="请选择是否重点"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="comment">
            <el-input
              v-model="ruleForm.comment"
              maxlength="30"
              placeholder="备注"
              show-word-limit
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="form-button">
          <el-button type="primary" @click="onSubmit(formRef)">提交</el-button>
          <el-button @click="cancel">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  onMounted,
} from "vue";
// import { ElMessageBox } from "element-plus";
import { ElMessage } from "element-plus";
import {
  basepeoplesave,
  basepeopleupdate,
  getSyncIdList,
} from "@/api/communityCare/communityCareApi.js";
import { getDict } from "@/api/constant";
import _ from "lodash";
export default defineComponent({
  props: {
    status: {
      type: Number,
      default: 1,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const formRef = ref(null);
    const state = reactive({
      listLibrary: null,
      syncIdList: null,
      ruleForm: {
        libraryName: "",
        libraryFlag: 1, //库类别  1人；2 车
        libraryType: "",
        libraryAbbreviation: "",
        syncId: "",
        syncFlag: "",
        importanceFlag: "",
        comment: "",
      },

      rules: {
        libraryName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        libraryType: [
          {
            required: true,
            message: "请选择类型",
            trigger: "blur",
          },
        ],
      },
      libraryFlagData: [
        { value: "重点人员库", code: 1 },
        { value: "重点车辆库", code: 2 },
      ],
    });
    const methods = {
      onSubmit(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            let res = {};
            if (state.ruleForm.libraryFlag === 2) {
              if (state.ruleForm.libraryType === "2") {
                state.ruleForm.libraryType = "-6";
              } else if (state.ruleForm.libraryType === "3") {
                state.ruleForm.libraryType = "-7";
              }
            }

            if (props.status === 1) {
              res = await basepeoplesave(state.ruleForm);
            } else {
              for (const i in state.ruleForm) {
                if (state.ruleForm[i] === null) {
                  delete state.ruleForm[i];
                }
              }
              res = await basepeopleupdate(state.ruleForm);
            }
            if (res.code === 0) {
              state.dialogVisible = false;
              ElMessage.success("操作成功");
            }
            methods.cancel();
          } else {
            console.log("error submit!");
            return false;
          }
        });
      },
      cancel() {
        context.emit("cancel");
      },
      changeLibraryFlag() {
        methods.codeAxios();
        methods.syncIdListAios();
      },
      async codeAxios() {
        let arr = ["2", "3"]; //只展示黑 白名单

        const res = await getDict("listLibraryType");
        res.dict = res.dict.filter((item) => {
          return arr.includes(item.code);
        });
        state.listLibrary = res;
      },
      async syncIdListAios() {
        let arrType =
          state.ruleForm.libraryFlag == 1 ? ["2", "3"] : ["-6", "-7"]; //只展示黑 白名单
        const params = { sign: state.ruleForm.libraryFlag + "", isPage: false };
        const res = await getSyncIdList(params);
        state.syncIdList = res.page.list.filter((item) => {
          return arrType.includes(item.type);
        });
      },
    };
    onMounted(() => {
      methods.codeAxios();
      methods.syncIdListAios();
    });
    watchEffect(() => {
      if (props.status === 2) {
        const form = { ...state.ruleForm, ...props.form };
        state.ruleForm = _.cloneDeep(form);
      }
    });
    return {
      ...toRefs(state),
      ...methods,
      formRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
  width: 100%;
  max-height: 500px;
  overflow: auto;
  .el-form-item {
    width: 90%;
    .form-button {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-left: 50px;
    }
  }
}
</style>